import React from 'react';
import { useAddressStep, type AddressData } from './useAddressStep';
import { AuthAddressStepView } from './AuthAddressStepView';

type AuthAddressStepProps = {
    loading?: boolean;
    onAddressSubmit: (address: AddressData) => void;
    defaultAddress?: AddressData;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthAddressStep: React.FC<AuthAddressStepProps> = ({
    loading,
    onAddressSubmit,
    defaultAddress,
    error,
    dismissError,
}) => {
    const {
        register,
        errors,
        street,
        streetError,
        zipValue,
        countryValue,
        predictions,
        showSuggestions,
        handleStreetChange,
        handleSuggestionSelect,
        hideSuggestions,
        onSubmit,
    } = useAddressStep(onAddressSubmit, defaultAddress);

    return (
        <AuthAddressStepView
            register={register}
            errors={errors}
            loading={loading}
            street={street}
            streetError={streetError}
            zipValue={zipValue}
            countryValue={countryValue}
            predictions={predictions}
            showSuggestions={showSuggestions}
            handleStreetChange={handleStreetChange}
            handleSuggestionSelect={handleSuggestionSelect}
            hideSuggestions={hideSuggestions}
            onSubmit={onSubmit}
            error={error}
            dismissError={dismissError}
        />
    );
};
